export default __webpack_public_path__ + "static/media/013-xylophone.b1c193e0.svg";